import styled from 'styled-components';

interface IContainerProps {
  marginLeft?: string;
}

export const Container = styled.div<IContainerProps>`
  margin-left: ${props => props.marginLeft || '5px'};
  text-align: center;
  display: inline-block;
`;

interface IBadgeContainerProps {
  marginLeft?: string;
  backgroundColor?: string;
  textColor?: string;
  width?: string;
  height?: string;
}

export const BagdeContainer = styled.div<IBadgeContainerProps>`
  background-color: ${props => props.backgroundColor || '#888'};
  color: ${props => props.textColor || '#fff'};
  border-radius: 50px;
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export interface IBadgeContent {
  fontSize?: string;
}

export const BagdeContent = styled.span<IBadgeContent>`
  font-size: ${props => props.fontSize || '0.9em'};
`;

export const TooltipLine = styled.div`
  text-align: left;
`;